import { GodziDropResultType, Button, soundManager, SoundType, t } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'
import { useBetDetailStore, GameType, SpinType } from '../../domain/betDetail/store/betDetailStore'
import { Container, Text } from '@pixi/react'
import { memo } from 'react'
import { DrawBg } from './DrawBg'

interface DetailTabProps {
  godziResultType: GodziDropResultType
  isVoucherBet: boolean
  isFromOpBetDetail: boolean
}

const titleTextStyle = new TextStyle({
  fontSize: 42,
  fontWeight: '600',
  fill: '#FFFFFF',
})

export const DetailTab = memo((props: DetailTabProps) => {
  const shouldShowGodziTab = props.godziResultType !== GodziDropResultType.None

  const mainGameTabPress = () => {
    if (!props.isFromOpBetDetail) {
      soundManager.play(SoundType.buttonConfirm)
    }
    useBetDetailStore.setState({
      selectShowGameType: GameType.MainGame,
      selectSpinType: SpinType.MainSpin,
      currentMgIndex: 0,
      currentFgIndex: 0,
    })
  }
  const godziGameTabPress = () => {
    if (!props.isFromOpBetDetail) {
      soundManager.play(SoundType.buttonConfirm)
    }
    useBetDetailStore.setState({
      selectShowGameType: GameType.GodziGame,
      selectSpinType: SpinType.MainSpin,
      currentMgIndex: 0,
      currentFgIndex: 0,
    })
  }

  return (
    <Container name="DetailTab">
      {shouldShowGodziTab
        ? (
            <>
              <Button
                name="MainGameTab"
                x={10}
                y={130}
                width={530}
                height={75}
                defaultView="btn_mg_normal"
                enabled={true}
                onPress={mainGameTabPress}
              />

              <Text name="normalTabTitle" text={t('betDetail_detail_tab_normal')} x={280} y={165} anchor={[0.5, 0.5]} style={titleTextStyle} />

              <Button
                name="GodziGameTab"
                x={540}
                y={130}
                width={530}
                height={75}
                defaultView="btn_godzi_normal"
                enabled={true}
                onPress={godziGameTabPress}
              />
              <Text name="godziTabTitle" text={t('betDetail_detail_tab_godzi')} x={810} y={165} anchor={[0.5, 0.5]} style={new TextStyle({ fontSize: 42, fontWeight: '600', fill: '#F5E781' })} />
            </>
          )
        : (

            <Container name="DetailTab" x={10} y={130}>
              <DrawBg x={0} y={0} width={1060} height={75} border={{ color: '#2A2A2C', width: 1 }} radius={10} backgroundColor="#2A2A2C" />
              <Text
                name="normalTabTitle"
                text={
                  props.isVoucherBet
                    ? t('betDetail_detail_tab_voucher')
                    : t('betDetail_detail_tab_normal')
                }
                x={530}
                y={40}
                anchor={[0.5, 0.5]}
                style={titleTextStyle}
              />
            </Container>
          )}
    </Container>
  )
})
